<div class="container dashboard-threshold-chart">
    <div *ngFor="let item of data; let index = index; let last = last;">
        <div class="item" [style.background-color]="item.backgroundColor">
            <span class="font-color-grey no-wrap value" *ngIf="!last">{{ item.value | formattedNumber : locale }}</span>
            <span class="percent" [ngClass]="{ 'font-color-grey': 0 > currentValue || currentValueIndex !== index }">
                {{ item.percent }}%
            </span>
            <div class="current-value no-wrap" [style.bottom]="bottom"
                *ngIf="currentValue >= 0 && currentValueIndex === index">
                <span>{{ currentValue | formattedNumber : locale }}</span>
            </div>
        </div>
    </div>
    <div class="font-color-grey margin-top-half text-align-center">
        {{ 'D16' | translate : locale : placeholders }}
    </div>
</div>